import React from "react";
import PageHeader from '@components/PageHeader';
import PageFooter from '@components/PageFooter';
import EventStore from '@stores/EventStore';
import WelcomeStore from '@stores/WelcomeStore';
import { observer } from 'mobx-react';
import { reaction, observable } from 'mobx';

@observer
export default class MessagePage extends React.Component {
    @observable title;
    @observable messageHTML;
    
    constructor() {
        super();
        this.setupPage();
    }

    setupPage = () => {
        this.title = "Verizon";
        if(EventStore.eventObj.payload.headerTitle) {
            this.title = EventStore.eventObj.payload.headerTitle;
        }
        if(EventStore.eventObj.payload.message) {
            this.messageHTML = EventStore.eventObj.payload.message;
        }
    }

    endReaction = reaction(() => EventStore.eventObj, () => {
        if(EventStore.eventObj.event === 'pageNavigation' && EventStore.eventObj.payload.pageName === 'status') {
            this.setupPage();
        }
    });

    render() {
        return (
            <div>
                <PageHeader title={this.title}/>
                <div className="margin-bot-10 center">
                    <div dangerouslySetInnerHTML={{__html: this.messageHTML}} />
                </div>
                <PageFooter />
            </div>
        );
    }

    componentWillUnmount() {
        this.endReaction();
    }
}


// WEBPACK FOOTER //
// ./src/js/pages/MessagePage.js